import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { ModalController, NavController } from '@ionic/angular';
import { DatatableComponent } from '@swimlane/ngx-datatable';
import { lastValueFrom } from 'rxjs';
import { AuthService } from 'src/app/services/auth.service';
import { NotificationService } from 'src/app/services/notification.service';
import { SharedStateService } from 'src/app/services/sharedState.service';
import { SignalRService } from 'src/app/services/signalR.service';
import { TranslateConfigService } from 'src/app/services/translate-config.service';
import { SignalRMessage } from 'src/app/shared/models/event.model';
import { MESSAGE_TYPE } from 'src/constants/message.constant';

@Component({
  selector: 'app-notification-dialog',
  templateUrl: './notification-dialog.component.html',
  styleUrls: ['./notification-dialog.component.scss'],
})
export class NotificationDialogComponent implements OnInit {
  // messages = [
  //   {
  //     title: 'title',
  //     message: 'message'
  //   },
  //   {
  //     title: 'title 1',
  //     message: 'message 1'
  //   }
  // ]
  @ViewChild('dataTable', { static: false })
  public dataTable!: DatatableComponent;
  notifications: any[] = [];
  private isUser = false;
  pageSize = 5;
  pageIndex = 0;
  total = 0;
  isLoadingRead: boolean[] = [];
  hasCountUnread = false;
  constructor(
    private modalController: ModalController,
    private translateService: TranslateConfigService,
    private signalRService: SignalRService,
    private notificationService: NotificationService,
    private authService: AuthService,
    private router: Router,
    private navCtrl: NavController,
    private sharedStateService: SharedStateService
  ) {}

  async ngOnInit() {
    await this.getData();
  }

  async getData() {
    const res = await lastValueFrom(
      this.notificationService.getNotificationsV2(this.pageIndex, this.pageSize)
    );

    this.notifications = res?.items;
    this.total = res?.total;
  }

  handlePageChange(event: any): void {
    this.pageIndex = event.offset;
    this.getData();
  }

  close() {
    this.modalController.dismiss();
  }

  doNotification(event: any, data: any, index: number): void {
    event.preventDefault();
    event.stopPropagation();
    this.markRead(data, index);
  }

  private markRead(row: any, i: number): void {
    this.isLoadingRead[i] = true;
    this.notificationService.markReadNotification(row.id).subscribe(
      (res) => {
        // this.notificationService.setCount(res);
        this.getData();

        this.notificationService.isHaveUnread().subscribe((isUnread) => {
          if (!isUnread?.isHaveUnread)
            this.sharedStateService.setIsHaveUnreadNotificationState(false);
        });
      },
      (err) => {},
      () => {
        this.isLoadingRead[i] = false;
      }
    );
  }

  renderMessage(item: any): string {
    const data = item.title;

    if (data) {
      return this.translateContent(data);
    }

    return '';
  }

  translateContent(content: string): string {
    if (content.includes('|NOTIFY_PARAMS')) {
      const msg = content.split('|NOTIFY_PARAMS')[0];
      const paramSplit = content.split('|NOTIFY_PARAMS')[1];
      const errorParams = JSON.parse(paramSplit);

      const message = '' + msg;
      const result = this.translateService.getTranslationWithParam(
        message,
        errorParams
      );
      // console.log(message, result);
      return result;
    }

    return this.translateService.getTranslation(content);
  }

  async handleClickNotification(item: any) {
    if (item.isBlockClick && item.type == 'Emegency') {
      return;
    }
    this.modalController.dismiss();
    await this.redirectUrl(item);
  }

  async redirectUrl(item: any) {
    if (!item.isRead) {
      this.notificationService.markReadNotification(item.id).subscribe(() => {
        this.getData();
      });
    }

    const data = JSON.parse(item.data);
    let message: SignalRMessage = {
      latitude: undefined,
      longitude: undefined,
      senderId: undefined,
      time: undefined,
      type: undefined,
      text: undefined,
      source: undefined,
      icon: undefined,
      title: undefined,
      iconColor: undefined,
      id: undefined,
      shifId: undefined,
      rosterId: undefined
    };
    switch (item.type) {
      case 'Emergency':
      case 'Emegency':
        // Show Emergency Dialog
        // console.log(data);
        message = {
          latitude: data.Latitude,
          longitude: data.Longitude,
          senderId: item.fromUserId,
          time: data.Time,
          type: data.Type,
          text: data.Text,
          source: data.Source,
          icon: data.Icon,
          title: data.Title,
          iconColor: data.IconColor,
          id: item.Id,
          shifId: data.ShiftId,
          rosterId: data.RosterId
        };
        await this.signalRService.showEmergencyDialog(message);
        break;
      case MESSAGE_TYPE.CHAT_NOTIFICATION:
        // Show Message Dialog
        message = {
          latitude: data.Latitude,
          longitude: data.Longitude,
          senderId: data.SenderId,
          time: data.Time,
          type: data.Type,
          text: data.Text,
          source: data.Source,
          icon: data.Icon,
          title: data.Title,
          iconColor: data.IconColor,
          id: item.Id,
          shifId: data.ShiftId,
          rosterId: data.RosterId
        };
        await this.router.navigateByUrl(`/main/chat/${message.senderId}`);
        break;
      case MESSAGE_TYPE.PIN_DROPPED:
        if (data.ShiftId && data.RosterId) {
          let url = `/full-screen/staff-dashboard/${data.RosterId}/${data.ShiftId}`;
          if (this.authService.isClientUser) {
            url = `/main/admin/${data.RosterId}/${data.ShiftId}`;
          }
          // console.log(url);
          await this.navCtrl.navigateRoot(url);
        }
        break;
      default:
        break;
    }
  }

  markAllAsRead() {
    this.notificationService.readAllNotification().subscribe((res) => {
      this.getData();

      this.sharedStateService.setIsHaveUnreadNotificationState(false);
    });
  }
}
